module.exports = __webpack_public_path__ + "fonts/Charlie_Text-Regular.28ac7e8155002e72c7d8.woff2";